import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';

// Register necessary components
Chart.register(ArcElement, Tooltip, Legend);

const PieChart = ({labels, data, chartLabel, chartHeight}) => {
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: chartLabel,
                data: data,
                backgroundColor: ['#28a745', '#007bff', '#dc3545', '#ffc107'],
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
    };

    return (
        // <div className="col-12 col-md-8 mx-auto my-3">
        <div className="card">
            {/* <div className="card-header">Shipment Status Pie Chart</div> */}
            <div className="card-body" style={{ height: chartHeight + 'px' }}>
                <Pie data={chartData} options={options} />
            </div>
        </div>
        // </div>
    );
};

export default PieChart;
